<template>
  <div>
    <Loading v-if="loading"/>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="step-progress navbar-space no-padding">
        <div class="container step-container">
          <div class="step-title">
            <h4>การขอออกหนังสือค้ำประกัน e-LG Blockchain</h4>
          </div>
        </div>
      </section>

      <section class="personal-info-sc">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-12 col-xl-9 col-xs-fix">
              <div class="additonal-info-wrapper" id="accordion">
                <form>
                  <div class="card card-form">
                    <div
                      class="card-header first-header card-expandable"
                      id="headingOne"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <div class="title">
                        <i class="feather-icon icon-file-plus"></i>
                        <h5 class="mb-0">ประเภทการขอออกหนังสือค้ำประกัน</h5>
                      </div>
                    </div>

                    <div class="card-body compact-padding">
                      <div class="compact-padding">
                        <div class="form-row">
                          <div class="form-group col-md-4">
                            <b-form-checkbox
                              v-model="reqTypeNew"
                              value="accepted"
                              unchecked-value="not_accepted"
                              @change="checkReqType('NEW')"
                            >ออกหนังสือค้ำประกัน</b-form-checkbox>
                          </div>
                          <div class="form-group col-md-4">
                            <b-form-checkbox
                              v-model="reqTypeExt"
                              value="accepted"
                              unchecked-value="not_accepted"
                              @change="checkReqType('EXT')"
                            >ต่ออายุหนังสือค้ำประกัน</b-form-checkbox>
                          </div>
                          <div class="form-group col-md-4">
                            <b-form-checkbox
                              v-model="reqTypeInc"
                              value="accepted"
                              unchecked-value="not_accepted"
                              @change="checkReqType('INC')"
                            >เพิ่มวงเงินหนังสือค้ำประกัน</b-form-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="card-header first-header card-expandable"
                      id="headingOne"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <div class="title">
                        <i class="feather-icon icon-file-plus"></i>
                        <h5 class="mb-0">รายละเอียดการขอค้ำประกัน</h5>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div class="card-body compact-padding">
                        <div class="default-padding">
                          <div class="data-display mb-3">
                            <table class="two-col-data">
                              <tbody>
                                <tr>
                                  <th>Tax ID</th>
                                  <td class="important">{{appVo.requesterTaxId}}</td>
                                </tr>

                                <tr>
                                  <th>ชื่อลูกค้า (Th)</th>
                                  <td>{{appVo.requesterNameTh}}</td>
                                </tr>

                                <tr>
                                  <th>ชื่อลูกค้า (En)</th>
                                  <td>{{appVo.requesterNameEn}}</td>
                                </tr>

                                <tr>
                                  <th>ที่อยู่ลูกค้า</th>
                                  <td>{{appVo.requesterAddr}}&nbsp;&nbsp;{{appVo.requesterDistrict}}&nbsp;&nbsp;{{appVo.requesterProvince}}&nbsp;&nbsp;{{appVo.requesterZipcode}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="form-row">
                            <div class="form-group col-md-12">
                              <label>ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)</label>
                              <select v-model="beneficiary" class="form-control" ref= 'input' @change="getLgTypeList()">
                                <option v-for="option in beneficiaryList" v-bind:value="{ beneTaxId: option.taxid, beneGroup: option.group}">
                                    {{ option.nameTH }}
                                </option>
                            </select>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="form-group col-md-12">
                              <label>ประเภทค้ำประกัน</label>
                              <select v-model="lgType" class="form-control">
                                <option v-for="option in custLgTypeList" v-bind:value="option.contingentId">
                                    {{ option.lgNameTh }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="form-group col-md-12">
                              <label>หมายเลขบัญชีวงเงิน</label>
                              <select v-model="accountNo" class="form-control">
                                <option v-for="option in commList" v-bind:value="option.accountNo">
                                    {{ option.accountNo }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="option-form mb-4">
                            <div class="form-group">
                              <label>เพื่อค้ำประกันในนาม</label>
                              <div class="input-group">
                                <button type="button" class="btn btn-secondary-custom btn-icon btn-minus">
                                  <i class="feather-icon icon-minus"></i>
                                </button>
                                <input type="text" class="form-control" placeholder="Tax ID">
                                <input type="text" class="form-control" placeholder="ชื่อภาษาไทย">
                                <input type="text" class="form-control" placeholder="ชื่อภาษาอังกฤษ">
                                <button type="button" class="btn btn-secondary-custom btn-icon btn-plus">
                                  <i class="feather-icon icon-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="form-group col-md-6">
                              <label>จำนวนเงินค้ำประกัน(บาท)</label>
                                <input v-model="lgAmt" type="text" class="form-control" placeholder="กรุณากรอกจำนวน">
                            </div>
                          </div>

                          <keep-alive>
                            <component :is="dynamicBene"/>
                          </keep-alive>

                          <div class="form-row">
                            <div class="form-group col-md-3">
                              <label>ระยะเวลาในการค้ำประกัน</label>
                              <b-form-radio v-model="periodType" v-bind:value="1">มีกำหนดระยะเวลา</b-form-radio>
                            </div>
                            <div class="form-group no-label col-md-2">
                              ตั้งแต่วันที่
                            </div>
                            <div class="form-group no-label col-md-3">
                              <!--<b-form-input v-model="periodStartDate1" type="date" placeholder="" config="{format: 'DD/MM/YYYY'}" />-->
                              <date-picker v-model="periodStartDate1" lang="en"  format="DD/MM/YYYY" placeholder=""></date-picker>
                            </div>

                            <div class="form-group no-label col-md-1">
                              ถึงวันที่
                            </div>
                            <div class="form-group no-label col-md-3">
                              <date-picker v-model="periodEndDate" lang="en"  format="DD/MM/YYYY" placeholder=""></date-picker>
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="form-group no-label col-md-3">
                              <b-form-radio v-model="periodType" v-bind:value="2">ไม่มีกำหนดระยะเวลา</b-form-radio>
                            </div>

                            <div class="form-group no-label col-md-2">
                              ตั้งแต่วันที่
                            </div>
                            <div class="form-group no-label col-md-3">
                              <date-picker v-model="periodStartDate2" lang="en"  format="DD/MM/YYYY" placeholder=""></date-picker>
                            </div>
                          </div>

                        </div>

                        <hr>

                        <div class="default-padding">
                          <div class="form-row">
                            <div class="form-group col-md-6">
                              <label>อัตราค่าธรรมเนียม(บาท)</label>
                              <input type="text" class="form-control" placeholder="" disabled>
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="form-group col-md-6">
                              <label>ตัดบัญชีค่าธรรมเนียมอัตโนมัติ</label>
                              <input type="text" class="form-control" placeholder="" disabled>
                            </div>
                            <div class="form-group col-md-6">
                              <label>จำนวนเงินคงเหลือในบัญชี(บาท)</label>
                              <input type="text" class="form-control" placeholder="" disabled>
                            </div>
                          </div>
                        </div>

                        <hr>

                        <div class="default-padding">
                          <div class="form-row">
                            <div class="form-group col-md-6">
                              <label>ค่าอากรแสตมป์</label>
                              
                            </div>
                          </div>

                          <div class="form-row">
                            <div class="form-group col-md-4">
                              <label>ต้นฉบับ(บาท)</label>
                              <input v-model="majorStampAmt" type="text" class="form-control" placeholder="" disabled>
                            </div>
                            <div class="form-group col-md-4">
                              <label>คู่ฉบับ(บาท)</label>
                              <input v-model="minorStampAmt" type="text" class="form-control" placeholder="" disabled>
                            </div>
                            <div class="form-group col-md-4">
                              <label>จำนวนเงินเดิม(บาท)</label>
                              <input v-model="dutyStampAmt" type="text" class="form-control" placeholder="" disabled>
                            </div>
                          </div>

                          
                        </div>

                        <div
                      class="card-header first-header card-expandable"
                      id="headingOne"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <div class="title">
                        <i class="feather-icon icon-file-plus"></i>
                        <h5 class="mb-0">เอกสารประกอบเพิ่มเติม</h5>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >

                    </div>
                    <div class="card-body compact-padding">
                        <div class="default-padding">
                          <vue-dropzone
                                ref="myVueDropzone"
                                id="dropzone"
                                v-on:vdropzone-removed-file="imageRemoved"
                                :options="dropzoneOptions"
                              ></vue-dropzone>
                        </div>
                    </div>

                      </div>
                    </div>
                  </div>

                  <!--hidden field-->{{reqNo}}
                  <!--<input type="hidden" v-model="reqNo">-->
                  
                  <div class="d-flex justify-content-center mt-4">
                    <div class="col-6 col-sm-5 col-lg-5 col-xl-4">
                      <div class="cta-btn single-btn">
                        <button class="btn btn-lg btn-primary-ktb" type="button" @click="saveRequest()">บันทึก</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter/>
    </div>

  </div>                    
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import DatePicker from 'vue2-datepicker';
import DatePicker from "@/resources/datepicker/vue2-datepicker";


export default {
  props: ["beneCode","lg"],
  components: {
    AppFooter,
    AppHeader,
    vueDropzone: vue2Dropzone,
    DatePicker,
  },
  name: "requestMain",
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },

    dynamicBene() {
      const beneCode = localStorage.getItem("beneGroup");
      const lgType = localStorage.getItem("lgType");
      console.log(beneCode+"  :  "+lgType);
      // const beName = this.beneCode
      //if (beneCode === undefined) {
      //  return () => import(`@/components/request/default`);
      //}

      return () => import(`@/components/request/${beneCode}_${lgType}`);
      // return () => import(`@/components/request/default`);
    }

  },
  methods: {
    getLgTypeList: function() {
      //console.log("taxid:"+taxid);
      apiClient.get("/api/home/getBeneficiaryProfile/"+beneficiary.beneTaxId).then(resp => {
        this.custLgTypeList = resp.data;
      });
    },

    checkReqType: function(type){
      if(type=="NEW" && this.reqTypeNew=="accepted"){
        this.reqTypeExt = "not_accepted";
        this.reqTypeInc = "not_accepted";
      }

      if((type=="EXT" || type=="INC") && this.reqTypeNew=="accepted"){
        this.reqTypeExt = "not_accepted";
        this.reqTypeInc = "not_accepted";
      }

      //alert("checkReqType : "+type);
    },

    imageRemoved(file, error, xhr) {
      alert("test");
    },
    saveRequest: function(){
      const{reqNo,reqTypeNew,reqTypeExt,reqTypeInc} = this;
      
      //var reqType = "";
      if(this.reqTypeNew=='accepted'){
          this.reqType = "NEW";
      }else{
        if(this.reqTypeExt=='accepted'){
          this.reqType = "EXT";
        }
        if(this.reqTypeExt=='accepted'){
          if(this.reqType==''){
            this.reqType = "INC";
          }else{
            this.reqType = this.reqType+"-INC";
          }          
        }
      }

      //set periodStartDate
      if(this.periodType=="1")
        this.periodStartDate = this.periodStartDate1;
      else
        this.periodStartDate = this.periodStartDate2;

      console.log("reqType : "+this.reqType);
      if(this.reqType==""){
        alert("กรุณาเลือกประเภทการขอออกหนังสือค้ำประกัน");
        return false;
      }else{
        alert("reqType:"+this.reqType+",lgType:"+this.lgType);
        apiClient.post("/api/elg/request/"+localStorage.getItem("registerVerifyId"), 
        { 
          reqNo: reqNo,
          status: "PS",
          reqType: this.reqType,
          cifNo: localStorage.getItem("cifNo"),
          requesterTaxId: this.appVo.requesterTaxId,
          requesterNameTh: this.appVo.requesterNameTh,
          requesterNameEn: this.appVo.requesterNameEn,
          beneTaxId: this.beneficiary.beneTaxId,
          contingentTypeId: this.lgType,
          lgAmt: this.lgAmt,
          periodType: this.periodType,
          periodStartDate: this.periodStartDate

        }).then(resp => {
          // if(resp.data.code=='0000'){//success
          //     //alert msg บันทึกข้อมูลเรียบร้อย
          //     alert("บันทึกข้อมูลเรียบร้อย");
          //     this.$router.push("/firstPageReg");
          // }
        });

      }
      
      /*apiClient.post("/api/customer/contractBack/"+localStorage.getItem("registerVerifyId"), 
      { 
        email: this.email, 
        telNo: this.telNo
      }).then(resp => {
        if(resp.data.code=='0000'){//success
            //alert msg บันทึกข้อมูลเรียบร้อย
            alert("บันทึกข้อมูลเรียบร้อย");
            this.$router.push("/firstPageReg");
        }
      });*/
    }
  },
  data() {
    return {
      reqNo:"",
      reqType:"",
      reqTypeNew:"",
      reqTypeExt:"",
      reqTypeInc:"",
      appVo: [],
      beneficiary:{ beneTaxId: localStorage.getItem("beneTaxId"), beneGroup: localStorage.getItem("beneGroup")},
      beneficiaryList: [],
      lgType:localStorage.getItem("lgType"),
      custLgTypeList: [],
      commList: [],//[{"commNo":"10000010000","amt":"10000000.00"},{"commNo":"10000020000","amt":"20000000.00"}],
      periodType:"",
      status1:"",
      status2:"",
      status3:"",
      accountNo:"",
      majorStampAmt:"",
      minorStampAmt:"",
      dutyStampAmt:"",
      periodStartDate:"",
      periodStartDate1:"",
      periodStartDate2:"",
      periodEndDate:"",
      lgAmt:"",
      
      
      dropzoneOptions: {
        url: "http://10.28.103.83:8080/api/customer/upload",
        thumbnailWidth: 150,
        maxFilesize: 3,
        addRemoveLinks: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.$store.state.auth.token//localStorage.getItem("user-token")
        },
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
        acceptedFiles: "image/*,application/pdf"
      }
    };
  },
  mounted() {
    // let tokenStr = localStorage.getItem("user-token");
    localStorage.setItem("cifNo","29956303");
    apiClient.get("/api/elg/defaultRequest/"+this.$route.params.registerVerifyId+"/29956303").then(resp => {
       this.appVo = resp.data;
       this.reqNo = resp.data.reqNo;
       this.commList = resp.data.accountLimit;
       this.majorStampAmt = resp.data.majorStampAmt;
       this.minorStampAmt = resp.data.minorStampAmt;
       this.dutyStampAmt = resp.data.dutyStampAmt;
    });

    apiClient.get("/api/home/getBeneficiary").then(resp => {
      this.beneficiaryList = resp.data;
    });

    apiClient.get("/api/home/getBeneficiaryProfile/"+localStorage.getItem("beneTaxId")).then(resp => {
        this.custLgTypeList = resp.data;
    });

    this.lgAmt = localStorage.getItem("amount");
  },
  
};
</script>
